import React from 'react';
import PropTypes from 'prop-types';
import {gql} from 'apollo-boost';
import {Query} from 'react-apollo';
import {fieldObjectSectionStyle} from '../helpers/graphQLShortcuts'
import Paragraph from "./Paragraph";
import {fieldObjectSectionStyleCss} from '../helpers/createStyles';
import {filterHeadline, filterHTML} from "../helpers/filters";
import SEFTable from "./Tables/SEFTable/SEFTable";


interface Data {
    paragraphById: {
        fieldTxtHeadline: string;
        fieldTxtSubTitle: string;
        fieldHtmlBody: string;
        fieldObjectSectionStyle: Array<{entity: Array}>;
        fieldObjectCtas: Array<{targetId: number}>;
    }
}

class SefTableComponentQuery extends Query<Data, {id: string}> {}

const GET_COMPONENT = gql`
query paragraphById($id: String!) {
  paragraphById:paragraphRevisionById(id: $id) {
    ... on ParagraphPreDefinedContentSefTable {
      fieldSefSectionHeader {
          entity {
            ... on Paragraph {
              ... on ParagraphInnerSectionHeader {
                fieldTxtHeadline
                fieldHtmlBody {
                  value
                  format
                  processed
                }
                fieldVarTextAlignment
              }
            }
        }
      }
      fieldSefSectionStyle {
          ${fieldObjectSectionStyle}
      }
    }
  }
}
`;

const SefTableComponent = ({id, markComponentLoadedAs, handleLoadedComponents}) => (
    <SefTableComponentQuery asyncMode query={GET_COMPONENT} variables={{ id }}>
        {({ loading, error, data }) => {
            if (loading) return null;
            if (error) {
                markComponentLoadedAs(id, true);
                return <div>{error}</div>;
            }

            const field = data.paragraphById;
            const header = field.fieldSefSectionHeader ? field.fieldSefSectionHeader.entity : null;
            const styles = fieldObjectSectionStyleCss(field.fieldSefSectionStyle);


            if (!styles.css.padding) {
                styles.css.padding = '16px 20px 60px 20px';
            }

            markComponentLoadedAs(id, true);

            return (
                <div className={`sefTableComponent${styles.classNames}`} style={styles.css} id={styles.id}>
                    {styles.childBackground.isActive && (
                        <div style={styles.childBackground.css}/>
                    )}
                    <div className="container">

                        {header && ((header.fieldTxtHeadline) || (header.fieldHtmlBody && header.fieldHtmlBody.processed)) && (
                            <div className="displayCards__header">
                                {header.fieldTxtHeadline && (
                                    // eslint-disable-next-line react/no-danger
                                    <h2 dangerouslySetInnerHTML={{__html: filterHeadline(header.fieldTxtHeadline)}} />
                                )}
                                {header.fieldHtmlBody && header.fieldHtmlBody.processed && (
                                    // eslint-disable-next-line react/no-danger
                                    <div dangerouslySetInnerHTML={{__html: filterHTML(header.fieldHtmlBody.processed)}}/>
                                )}
                            </div>
                        )}

                        
                        <SEFTable/>

                        {field.fieldObjectCtas && (
                            <div className="sefTableComponent__ctas">
                                {field.fieldObjectCtas.map(component => (
                                    <Paragraph key={`${id}_${component.targetId}`}
                                               id={String(component.targetId)}
                                               handleLoadedComponents={handleLoadedComponents}/>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            );
        }}
    </SefTableComponentQuery>
);

SefTableComponent.propTypes = {
    id: PropTypes.number.isRequired,
    markComponentLoadedAs: PropTypes.func.isRequired,
    handleLoadedComponents: PropTypes.func.isRequired
};

export default SefTableComponent;



// WEBPACK FOOTER //
// ./frontend/components/SefTableComponent.jsx